import { useState } from 'react';
import truncate from 'lodash/truncate';

import { CopyIcon } from './DebugTree.icons';
import { TreeExpandArrow, TreeKeyName, TreeLI, TreeUL, TreeValue } from './DebugTree.styles';
import Tooltip from 'rc-tooltip';

const MAX_STRING_LENGTH = 26;

export const DebugTree = ({ data, pathBase = '' }) => {
  // collapsed state for each key
  const [collapsed, setCollapsed] = useState(Object.fromEntries(Object.keys(data).map((key) => [key, true])));

  return (
    <TreeUL>
      {Object.entries(data).map(([key, value]) => {
        const fieldPath = pathBase ? pathBase + '.' + key : key;
        const isObject = typeof value === 'object' && value !== null;
        const hasChildren = isObject && Object.keys(value).length > 0;
        const fieldValueString = isObject && !hasChildren ? '{}' : String(value);
        const collapsedCurrent = collapsed[key];
        const onClick = hasChildren ? () => setCollapsed({ ...collapsed, [key]: !collapsedCurrent }) : undefined;
        const handleCopyFieldPath = (e) => {
          // this is needed otherwise the click event will bubble up to the parent and collapse the tree
          e.stopPropagation();
          navigator.clipboard.writeText(fieldPath);
        };

        return (
          <TreeLI key={key} hasChildren={hasChildren} collapsed={collapsedCurrent}>
            {hasChildren && <TreeExpandArrow onClick={onClick} collapsed={collapsedCurrent} />}
            <TreeKeyName hasChildren={hasChildren} onClick={onClick}>
              <Tooltip
                placement="top"
                overlay={<span>{key}</span>}
                overlayClassName={key.length <= MAX_STRING_LENGTH && 'hidden'}
              >
                <div>{truncate(key, { length: MAX_STRING_LENGTH })}</div>
              </Tooltip>
              {/* we need this div, otherwise the svg get collapsed */}
              <div>
                <CopyIcon onClick={handleCopyFieldPath} />
              </div>
              {/* using hardcoded {} because empty object gets serialized as [Object object] */}
              {!hasChildren && (
                <TreeValue>
                  {fieldValueString.startsWith('http') ? (
                    <a href={fieldValueString} target="_blank" rel="noopener noreferrer">
                      {fieldValueString}
                    </a>
                  ) : (
                    fieldValueString
                  )}
                </TreeValue>
              )}
            </TreeKeyName>
            {/* recursively creating Tree at each children */}
            {hasChildren && !collapsedCurrent && <DebugTree data={value} pathBase={fieldPath} />}
          </TreeLI>
        );
      })}
    </TreeUL>
  );
};
